/**
 * Export
 */
export const get = state => state